import React from 'react';
import i18n from 'i18next';
import Modal from 'src/modules/shared/modal/components/modal';

const TermsModal = ({ onClose }) => {
  return (
    <Modal
      noClose={true}
      size="large"
    >
      <div className="signup-box__terms">
        <span
          className="signup-box__terms__close icon icon-close"
          onClick={() => {
            onClose();
          }}
        />
        <h3 className="signup-box__questions__title">
          {i18n.t('Research opportunities')}
        </h3>
        <div className="signup-box__terms__content">
          <p>As part of the HealthUnlocked mission, we are committed to sharing research opportunities that can further help to improve the health of our members.</p>
          <p>To inform you about these opportunities, we need to be able to contact you via email.</p>
          <p>To clarify, emails will:</p>
          <ul>
            <li>Inform you of research opportunities in which your insights and experiences could help patients in the future</li>
            <li>Research (in the form of surveys or clinical trials) are all run by trusted partners, including patient organisations, doctors and other healthcare professionals and institutions and industry (e.g. Department of Health, Health providers)</li>
            <li>Be relevant to you and the communities you follow</li>
            <li>Be very occasional</li>
          </ul>
        </div>
      </div>
    </Modal>
  );
};

export default TermsModal;



// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/signup/researchModal.js